import { CampaignType } from '../../../types/Campaign.js';
import '../../../node_modules/tslib/tslib.es6.js';
import '../../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import '../../../types/filters.js';
import { BC_VIDEOS } from '../../../utils/assetUtils.js';
import '../../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import { formatMoney } from '../../../utils/stringUtils.js';
import '../../../utils/broadcast.js';
import '../../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'react';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '../../../types/product.js';
import '../../../api/graphQl/brand.js';
import '../../../api/graphQl/product.js';
import '@brandclub/types';

/**
 * @returns product page reward pop up props
 */
var getProductRewardPopupProps = function (_a) {
    var reward = _a.reward, brandName = _a.brandName, retailer = _a.retailer;
    var rewardType = reward.rewardType, rewardAmount = reward.rewardAmount;
    switch (rewardType) {
        case CampaignType.DailyDealsRewardCampaign:
            return {
                showIcon: true,
                title: 'Daily Deals rewards',
                subtitle: "Earn ".concat(formatMoney(rewardAmount), " when you purchase this product today. Access rewards in the Brandclub app."),
                redirect: {
                    text: "I already have the Brandclub app",
                    url: retailer.retailerProductPageUrl,
                },
                phoneInput: {
                    redirectionText: "Finish and checkout on ".concat(retailer.name),
                    redirectionUrl: retailer.retailerProductPageUrl,
                    autoRedirectOnSuccess: true,
                },
                video: {
                    videoUrl: BC_VIDEOS.DAVID.video,
                    coverImageUrl: BC_VIDEOS.DAVID.coverImage,
                },
            };
        case CampaignType.PurchaseRewardCampaign:
            return {
                showIcon: true,
                title: 'Purchase rewards',
                subtitle: "Earn ".concat(formatMoney(rewardAmount), " when you purchase this product. Access rewards in the Brandclub app."),
                redirect: {
                    text: "I already have the Brandclub app",
                    url: retailer.retailerProductPageUrl,
                },
                phoneInput: {
                    redirectionText: "Finish and checkout on ".concat(retailer.name),
                    redirectionUrl: retailer.retailerProductPageUrl,
                    autoRedirectOnSuccess: true,
                },
                video: {
                    videoUrl: BC_VIDEOS.JESSICA.video,
                    coverImageUrl: BC_VIDEOS.JESSICA.coverImage,
                },
            };
        case CampaignType.MembershipRewardCampaign:
            return {
                showIcon: true,
                title: 'Membership rewards',
                subtitle: "Earn ".concat(formatMoney(rewardAmount), " when you join the ").concat(brandName, " club. Access rewards in the Brandclub app."),
                phoneInput: {
                    closeDialogText: 'Continue shopping',
                },
                video: {
                    videoUrl: BC_VIDEOS.HOME_HEAD.video,
                    coverImageUrl: BC_VIDEOS.HOME_HEAD.coverImage,
                },
            };
        case CampaignType.SurveyRewardCampaign:
            return {
                showIcon: true,
                title: 'Survey rewards',
                subtitle: "Earn ".concat(formatMoney(rewardAmount), " when you complete surveys from ").concat(brandName, ". Access rewards in the Brandclub app."),
                phoneInput: {
                    closeDialogText: 'Continue shopping',
                },
                video: {
                    videoUrl: BC_VIDEOS.ANGELA.video,
                    coverImageUrl: BC_VIDEOS.ANGELA.coverImage,
                },
            };
        case CampaignType.AffiliateRewardCampaign:
            return {
                showIcon: true,
                title: 'Affiliate rewards',
                subtitle: "Earn ".concat(formatMoney(rewardAmount), " when you refer each sale of this product."),
                sharePage: true,
                video: {
                    videoUrl: BC_VIDEOS.EMMA.video,
                    coverImageUrl: BC_VIDEOS.EMMA.coverImage,
                },
            };
        case CampaignType.ContentRewardCampaign:
            return {
                showIcon: true,
                title: 'Content rewards',
                subtitle: "Earn ".concat(formatMoney(rewardAmount), " when you view content from ").concat(brandName, ". Access rewards in the Brandclub app."),
                phoneInput: {
                    closeDialogText: 'Continue shopping',
                },
                video: {
                    videoUrl: BC_VIDEOS.MARCUS.video,
                    coverImageUrl: BC_VIDEOS.MARCUS.coverImage,
                },
            };
        case CampaignType.ReferralRewardCampaign:
            return {
                showIcon: true,
                title: 'Referral rewards',
                subtitle: "Earn ".concat(formatMoney(rewardAmount), " for each friend you refer to Brandclub. Access rewards in the Brandclub app."),
                phoneInput: {
                    closeDialogText: 'Continue shopping',
                },
            };
        case CampaignType.RetailerConnectRewardCampaign:
            return {
                showIcon: true,
                title: 'Connect rewards',
                subtitle: "Earn ".concat(formatMoney(rewardAmount), " when you connect retailer accounts. Access rewards in the Brandclub app."),
                phoneInput: {
                    closeDialogText: 'Continue shopping',
                },
                video: {
                    videoUrl: BC_VIDEOS.MARCUS.video,
                    coverImageUrl: BC_VIDEOS.MARCUS.coverImage,
                },
            };
        default:
            return {};
    }
};

export { getProductRewardPopupProps };
//# sourceMappingURL=util.js.map
